import { Stethoscope, Building2, Network, Scale, GraduationCap, BookOpen, FileText } from "lucide-react";
import { Breadcrumbs, Reveal, PrimaryButton } from "../components/common";
import { INDUSTRIES } from "../data/site";

const ICONS = { Stethoscope, Building2, Network, Scale, GraduationCap, BookOpen };

export default function Industries() {
  return (
    <>
      <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Industries" }]} />
      <section className="container-page py-12 lg:py-16">
        <span className="eyebrow">Industries</span>
        <h1 className="mt-4 max-w-3xl font-heading text-[34px] font-800 leading-[1.1] text-brand-ink md:text-[52px]">Documentation expertise across professional sectors.</h1>
        <p className="mt-4 max-w-2xl text-[17px] text-brand-muted md:text-[18px]">Healthcare specialisation complemented by legal, academic and business capability.</p>
      </section>
      <section className="pb-24">
        <div className="container-page grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {INDUSTRIES.map((ind, i) => {
            const Icon = ICONS[ind.icon] || FileText;
            return (
              <Reveal key={ind.title} delay={i % 3}>
                <div className="h-full rounded-2xl border border-brand-border bg-white p-7 transition-transform hover:-translate-y-1">
                  <span className="mb-5 flex h-12 w-12 items-center justify-center rounded-xl bg-brand-alt text-brand-slate"><Icon className="h-6 w-6" /></span>
                  <h2 className="font-heading text-[19px] font-700 text-brand-ink">{ind.title}</h2>
                  <p className="mt-2 text-[15px] leading-relaxed text-brand-muted">{ind.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
        <div className="container-page mt-12"><PrimaryButton to="/contact" testid="industries-page-cta">Discuss Your Requirement</PrimaryButton></div>
      </section>
    </>
  );
}
